import React, { Component } from "react";

class Footer extends Component {
  render() {
    const year = new Date().getFullYear();
    return (
      <footer className="footer-container">
        <small className="float-right">&copy; {year} - Sistemas Libellus</small>
      </footer>
    );
  }
}

export default Footer;
